<nb-card>
  <nb-card-body>
    <table>
      <tr>
        <td>Available Credits</td>
        <td>{{ (credits ? credits.value : 0) | gigaPixels }}</td>
      </tr>
      <tr>
        <td>Credits Limit</td>
        <td>{{ (credits ? credits.limit : 0) | gigaPixels }}</td>
      </tr>
    </table>
    <button nbButton status="info" size="small" (click)="showReportForm()">
      <nb-icon icon="credit-card-outline"></nb-icon>Request more credits
    </button>
  </nb-card-body>
</nb-card>
